import * as i0 from '@angular/core';
import { HostBinding, Input, Directive, signal, Injectable, EventEmitter, Output, Component, inject, ViewContainerRef, ElementRef, input, booleanAttribute, computed, model, PLATFORM_ID, Renderer2, effect, CUSTOM_ELEMENTS_SCHEMA, NgModule, contentChild, ContentChildren, HostListener, ViewChild, createComponent } from '@angular/core';
import * as i1 from 'ng-primitives/button';
import { NgpButton } from 'ng-primitives/button';
import { button, inputClearButton, inputButton, buttonsWrapper, input as input$1, tooltip, tooltipArrow, tw, formField, inputLabel, formDescription, formErrorIcon, formError, modalContent, modalCloseButtonWrapper, modalCloseButton, modal, modalTitle, modalOverlay, modalFooter, modalFooterContent, modalFooterControls, toast, divider, card, checkbox, label, accordion, accordionTrigger, accordionPanel, accordionContent } from '@limehome/spark-ui-styles';
import { NgControl } from '@angular/forms';
import * as i1$2 from 'ng-primitives/input';
import { NgpInput } from 'ng-primitives/input';
import * as i1$1 from '@ng-icons/core';
import { NgIconsModule, NgIconComponent, provideIcons, NgIcon } from '@ng-icons/core';
import { NgpTooltip, NgpTooltipTrigger, NgpTooltipTriggerToken } from 'ng-primitives-legacy/tooltip';
import * as i1$6 from '@angular/common';
import { DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { faEyeSlash, faEye, faCircleXmark, faCircleCheck } from '@ng-icons/font-awesome/regular';
import * as i1$3 from 'ng-primitives/form-field';
import { NgpFormField, NgpLabel, NgpDescription, NgpError } from 'ng-primitives/form-field';
import { faSolidXmark, faSolidCircleInfo, faSolidCheck } from '@ng-icons/font-awesome/solid';
import * as i1$4 from 'ng-primitives/dialog';
import { NgpDialogDescription, NgpDialog, NgpDialogTitle, injectDialogRef, NgpDialogTrigger } from 'ng-primitives/dialog';
import { ionInformationCircleOutline } from '@ng-icons/ionicons';
import { bootstrapExclamationTriangle } from '@ng-icons/bootstrap-icons';
import * as i1$5 from 'ng-primitives/toast';
import { NgpToast } from 'ng-primitives/toast';
import * as i1$7 from 'ng-primitives/checkbox';
import { NgpCheckbox } from 'ng-primitives/checkbox';
import * as i1$8 from 'ng-primitives/accordion';
import { NgpAccordion, NgpAccordionItem, NgpAccordionTrigger, NgpAccordionContent } from 'ng-primitives/accordion';
function InputButtonsComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-icon", 4);
  }
}
function InputButtonsComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-icon", 5);
  }
}
function InputButtonsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function InputButtonsComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onVisibilityClick());
    });
    i0.ɵɵtemplate(1, InputButtonsComponent_Conditional_2_Conditional_1_Template, 1, 0, "ng-icon", 4)(2, InputButtonsComponent_Conditional_2_Conditional_2_Template, 1, 0, "ng-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.visibilityButtonClasses);
    i0.ɵɵattribute("data-testid", "qa-" + ctx_r1.inputId + "-visibility-button")("aria-label", ctx_r1.isPasswordVisible() ? "Hide password" : "Show password")("aria-controls", ctx_r1.inputId)("aria-pressed", ctx_r1.isPasswordVisible());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isPasswordVisible() ? 1 : 2);
  }
}
const _c0 = ["[sparkInput]"];
const _c1 = ["dismissBtn"];
function ToastComponent_ng_template_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "ng-icon", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.toastStyles.icon());
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.iconBasedOnVariant);
  }
}
function ToastComponent_ng_template_0_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.toast.title);
  }
}
function ToastComponent_ng_template_0_div_8_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ToastComponent_ng_template_0_div_8_button_1_Template_button_click_0_listener() {
      const action_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      return i0.ɵɵresetView(action_r4.handler());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.toastStyles.action());
    i0.ɵɵattribute("data-testid", "toast-action-" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r4.label, " ");
  }
}
function ToastComponent_ng_template_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ToastComponent_ng_template_0_div_8_button_1_Template, 2, 3, "button", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.toast.actions)("ngForTrackBy", ctx_r1.trackByLabel);
  }
}
function ToastComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 1);
    i0.ɵɵlistener("swipeLeft", function ToastComponent_ng_template_0_Template_div_swipeLeft_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissToast());
    })("keydown.esc", function ToastComponent_ng_template_0_Template_div_keydown_esc_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissToast());
    });
    i0.ɵɵtemplate(2, ToastComponent_ng_template_0_div_2_Template, 2, 2, "div", 5);
    i0.ɵɵelementStart(3, "div", 6)(4, "div", 7);
    i0.ɵɵtemplate(5, ToastComponent_ng_template_0_p_5_Template, 2, 1, "p", 8);
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ToastComponent_ng_template_0_div_8_Template, 2, 2, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 10, 2);
    i0.ɵɵlistener("click", function ToastComponent_ng_template_0_Template_button_click_9_listener() {
      const dismiss_r6 = i0.ɵɵrestoreView(_r1).dismiss;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleDismiss(dismiss_r6));
    });
    i0.ɵɵelement(11, "ng-icon", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.toastStyles.base());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.toast.showIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.toastStyles.body());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.toast == null ? null : ctx_r1.toast.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.toast.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.toast == null ? null : ctx_r1.toast.actions == null ? null : ctx_r1.toast.actions.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.toastStyles.closeIcon());
  }
}
let ButtonDirective = /*#__PURE__*/(() => {
  class ButtonDirective extends NgpButton {
    variant;
    shape;
    background;
    size;
    additionalClasses;
    get classes() {
      return button({
        variant: this.variant,
        shape: this.shape,
        background: this.background,
        size: this.size,
        class: this.additionalClasses
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵButtonDirective_BaseFactory;
      return function ButtonDirective_Factory(__ngFactoryType__) {
        return (ɵButtonDirective_BaseFactory || (ɵButtonDirective_BaseFactory = i0.ɵɵgetInheritedFactory(ButtonDirective)))(__ngFactoryType__ || ButtonDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonDirective,
      selectors: [["", "sparkButton", ""]],
      hostVars: 2,
      hostBindings: function ButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      inputs: {
        variant: "variant",
        shape: "shape",
        background: "background",
        size: "size",
        additionalClasses: [0, "class", "additionalClasses"]
      },
      features: [i0.ɵɵHostDirectivesFeature([i1.NgpButton]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return ButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormFieldService = /*#__PURE__*/(() => {
  class FormFieldService {
    inputValue = signal('');
    value = this.inputValue.asReadonly();
    updateValue(value) {
      this.inputValue.set(value);
    }
    static ɵfac = function FormFieldService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormFieldService,
      factory: FormFieldService.ɵfac
    });
  }
  return FormFieldService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputButtonsComponent = /*#__PURE__*/(() => {
  class InputButtonsComponent {
    inputValue = signal('');
    inputId = '';
    showVisibilityButton = signal(false);
    isPasswordVisible = signal(false);
    toggleVisibility = new EventEmitter();
    clear = new EventEmitter();
    get clearButtonClasses() {
      return inputClearButton({
        hideClearButton: this.inputValue() === ''
      });
    }
    get visibilityButtonClasses() {
      return inputButton;
    }
    get wrapperClasses() {
      return buttonsWrapper();
    }
    onClearClick() {
      this.clear.emit();
    }
    onVisibilityClick() {
      this.isPasswordVisible.set(!this.isPasswordVisible());
      this.toggleVisibility.emit();
    }
    static ɵfac = function InputButtonsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputButtonsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputButtonsComponent,
      selectors: [["spark-input-buttons"]],
      hostVars: 2,
      hostBindings: function InputButtonsComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.wrapperClasses);
        }
      },
      outputs: {
        toggleVisibility: "toggleVisibility",
        clear: "clear"
      },
      standalone: false,
      decls: 3,
      vars: 5,
      consts: [["type", "button", "aria-label", "Clear", 3, "click"], ["name", "faCircleXmark"], ["type", "button", 3, "class"], ["type", "button", 3, "click"], ["name", "faEyeSlash"], ["name", "faEye"]],
      template: function InputButtonsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function InputButtonsComponent_Template_button_click_0_listener() {
            return ctx.onClearClick();
          });
          i0.ɵɵelement(1, "ng-icon", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, InputButtonsComponent_Conditional_2_Template, 3, 7, "button", 2);
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.clearButtonClasses);
          i0.ɵɵattribute("data-testid", "qa-" + ctx.inputId + "-clear-button")("aria-controls", ctx.inputId);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.showVisibilityButton() ? 2 : -1);
        }
      },
      dependencies: [i1$1.NgIcon],
      encapsulation: 2
    });
  }
  return InputButtonsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputDirective = /*#__PURE__*/(() => {
  class InputDirective {
    formFieldService = inject(FormFieldService, {
      optional: true
    });
    ngControl = inject(NgControl, {
      optional: true
    });
    viewContainerRef = inject(ViewContainerRef);
    elRef = inject(ElementRef);
    size = input();
    status = input();
    /**
     * If true, the padding and placeholder behavior is different to accommodate the floating labels form Spark UI
     * If false, the padding and placeholder behavior follows the native browser behavior
     * @default true
     */
    withSparkLabel = input(true, {
      transform: booleanAttribute
    });
    /**
     * If true, the form field will not update the internal form state,
     * which allows using multiple sparkInputs within a sparkFormField
     */
    formFieldIgnore = input(false, {
      transform: booleanAttribute
    });
    /**
     * If true, the input will have a clear button to reset the value
     * @default false
     */
    withClearButton = input(false, {
      transform: booleanAttribute
    });
    /**
     * If true, the input will have a visibility button to toggle the visibility of the input value
     */
    withVisibilityButton = input(true, {
      transform: booleanAttribute
    });
    inputButtonsComponent;
    lastKnownValue = '';
    showVisibilityButton = computed(() => this.withVisibilityButton() && this.elRef.nativeElement.getAttribute('type') === 'password');
    classes = computed(() => input$1({
      size: this.size(),
      status: this.status(),
      withSparkLabel: this.withSparkLabel(),
      withClearButton: this.withClearButton(),
      withVisibilityButton: this.showVisibilityButton()
    }));
    ngOnInit() {
      this.formFieldService?.updateValue(this.elRef.nativeElement.value);
      this.lastKnownValue = this.elRef.nativeElement.value;
      const element = this.elRef.nativeElement;
      const showInputButtons = !element.disabled && (this.withClearButton() || this.showVisibilityButton());
      if (showInputButtons) {
        this.inputButtonsComponent = this.viewContainerRef.createComponent(InputButtonsComponent);
        this.inputButtonsComponent.instance.clear.subscribe(() => this.setInputValue(''));
        this.inputButtonsComponent.instance.toggleVisibility.subscribe(() => element.setAttribute('type', element.getAttribute('type') === 'password' ? 'text' : 'password'));
        this.inputButtonsComponent.instance.inputId = element.id;
        this.inputButtonsComponent.instance.showVisibilityButton.set(this.showVisibilityButton());
        this.inputButtonsComponent.instance.inputValue.set(this.elRef.nativeElement.value);
      }
    }
    ngAfterViewInit() {
      // Check for value changes after view initialization
      this.updateInputValue();
    }
    /**
     * Updates form field service and Angular form control state
     */
    updateFormState(value) {
      // Update form field service to trigger validation
      if (!this.formFieldIgnore() && this.formFieldService) {
        this.formFieldService.updateValue(value);
      }
      // Update Angular form control if present
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setValue(value);
        this.ngControl.control.markAsDirty();
        this.ngControl.control.markAsTouched();
      }
    }
    /**
     * Updates the input value signal if the actual input value has changed
     */
    updateInputValue() {
      const currentValue = this.elRef.nativeElement.value;
      if (currentValue !== this.lastKnownValue) {
        this.lastKnownValue = currentValue;
        if (this.inputButtonsComponent) {
          this.inputButtonsComponent.instance.inputValue.set(currentValue);
        }
        this.updateFormState(currentValue);
      }
    }
    setInputValue(value) {
      this.elRef.nativeElement.value = value;
      this.lastKnownValue = value;
      if (this.inputButtonsComponent) {
        this.inputButtonsComponent.instance.inputValue.set(value);
      }
      this.updateFormState(value);
    }
    static ɵfac = function InputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InputDirective,
      selectors: [["input", "sparkInput", ""]],
      hostVars: 2,
      hostBindings: function InputDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function InputDirective_input_HostBindingHandler($event) {
            return ctx.setInputValue($event.target.value);
          })("change", function InputDirective_change_HostBindingHandler() {
            return ctx.updateInputValue();
          })("blur", function InputDirective_blur_HostBindingHandler() {
            return ctx.updateInputValue();
          })("focus", function InputDirective_focus_HostBindingHandler() {
            return ctx.updateInputValue();
          });
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes());
        }
      },
      inputs: {
        size: [1, "size"],
        status: [1, "status"],
        withSparkLabel: [1, "withSparkLabel"],
        formFieldIgnore: [1, "formFieldIgnore"],
        withClearButton: [1, "withClearButton"],
        withVisibilityButton: [1, "withVisibilityButton"]
      },
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$2.NgpInput,
        inputs: ["disabled", "disabled"]
      }])]
    });
  }
  return InputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TooltipDirective = /*#__PURE__*/(() => {
  class TooltipDirective extends NgpTooltip {
    get classes() {
      return tooltip();
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵTooltipDirective_BaseFactory;
      return function TooltipDirective_Factory(__ngFactoryType__) {
        return (ɵTooltipDirective_BaseFactory || (ɵTooltipDirective_BaseFactory = i0.ɵɵgetInheritedFactory(TooltipDirective)))(__ngFactoryType__ || TooltipDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TooltipDirective,
      selectors: [["", "sparkTooltip", ""]],
      hostVars: 2,
      hostBindings: function TooltipDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return TooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TooltipRegistry = /*#__PURE__*/(() => {
  class TooltipRegistry {
    static instance;
    activeTooltips = new Set();
    static getInstance() {
      if (!TooltipRegistry.instance) {
        TooltipRegistry.instance = new TooltipRegistry();
      }
      return TooltipRegistry.instance;
    }
    register(tooltip) {
      this.activeTooltips.add(tooltip);
    }
    unregister(tooltip) {
      this.activeTooltips.delete(tooltip);
    }
    closeOthers(except) {
      this.activeTooltips.forEach(tooltip => {
        if (tooltip !== except && tooltip.open()) {
          tooltip.open.set(false);
          tooltip.tooltipTriggerOpen.set(false);
        }
      });
    }
    closeAll() {
      this.activeTooltips.forEach(tooltip => {
        tooltip.open.set(false);
        tooltip.tooltipTriggerOpen.set(false);
      });
    }
  }
  return TooltipRegistry;
})();
let TooltipTriggerDirective = /*#__PURE__*/(() => {
  class TooltipTriggerDirective extends NgpTooltipTrigger {
    tooltip = input.required({
      alias: 'sparkTooltipTrigger'
    });
    flip = input(
    // Flipping disabled by default as the arrow is not displayed correctly if flipped
    false, {
      transform: booleanAttribute
    });
    placement = input('top', {
      alias: 'tooltipPlacement'
    });
    tooltipWithArrow = input(true);
    tooltipWithClose = input(false);
    tooltipTriggerOpen = model(false);
    tooltipTrigger = model('hover');
    // Optional fallback text if template extraction fails
    tooltipAccessibleText = input('');
    tooltipElement = null;
    arrowElement = null;
    visuallyHiddenElement = null;
    cleanupListeners = [];
    observer = null;
    globalClickListener = null;
    tooltipRegistry = TooltipRegistry.getInstance();
    routerSubscription = null;
    tooltipId = '';
    static tooltipCounter = 0;
    platformId = inject(PLATFORM_ID);
    globalDocument = inject(DOCUMENT);
    renderer = inject(Renderer2);
    elementRef = inject(ElementRef);
    router = inject(Router, {
      optional: true
    });
    constructor() {
      super();
      this.tooltipId = `tooltip-${++TooltipTriggerDirective.tooltipCounter}`;
      effect(() => {
        const isOpen = this.tooltipTriggerOpen();
        if (isOpen) {
          this.startObservingTooltip();
          this.tooltipRegistry.register(this);
          this.tooltipRegistry.closeOthers(this);
          this.addGlobalClickListener();
        } else {
          this.stopObservingTooltip();
          this.tooltipRegistry.unregister(this);
          this.removeGlobalClickListener();
        }
      }, {
        allowSignalWrites: true
      });
      effect(() => {
        const currentPlacement = this.placement();
        if (this.tooltipElement) {
          this.updateTooltipClasses(currentPlacement);
        }
      });
      effect(() => {
        if (isPlatformBrowser(this.platformId) && this.visuallyHiddenElement) {
          this.updateVisuallyHiddenText();
        }
      });
    }
    ngOnInit() {
      if (this.router) {
        this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
          this.closeTooltip();
        });
      }
    }
    ngAfterViewInit() {
      if (isPlatformBrowser(this.platformId)) {
        this.createVisuallyHiddenElement();
        this.addAriaAttributes();
      }
    }
    ngOnDestroy() {
      this.stopObservingTooltip();
      this.removeGlobalClickListener();
      this.removeVisuallyHiddenElement();
      this.cleanupListeners.forEach(cleanup => cleanup());
      this.cleanupListeners = [];
      this.tooltipRegistry.unregister(this);
      if (this.routerSubscription) {
        this.routerSubscription.unsubscribe();
        this.routerSubscription = null;
      }
      this.tooltipElement = null;
      this.arrowElement = null;
    }
    createVisuallyHiddenElement() {
      if (!isPlatformBrowser(this.platformId) || this.visuallyHiddenElement) return;
      this.visuallyHiddenElement = this.renderer.createElement('span');
      this.renderer.setAttribute(this.visuallyHiddenElement, 'id', this.tooltipId);
      this.renderer.setAttribute(this.visuallyHiddenElement, 'role', 'tooltip');
      this.renderer.addClass(this.visuallyHiddenElement, 'sr-only');
      this.updateVisuallyHiddenText();
      this.renderer.appendChild(this.elementRef.nativeElement, this.visuallyHiddenElement);
    }
    updateVisuallyHiddenText() {
      if (!this.visuallyHiddenElement) return;
      let textContent = this.extractTextFromRenderedTooltip();
      if (!textContent) {
        textContent = this.tooltipAccessibleText();
      }
      if (!textContent) {
        textContent = 'Tooltip content';
      }
      this.renderer.setProperty(this.visuallyHiddenElement, 'textContent', textContent);
    }
    extractTextFromRenderedTooltip() {
      if (!this.tooltipElement) return '';
      try {
        return this.tooltipElement.textContent?.trim() || '';
      } catch (error) {
        console.warn('[sparkTooltipTrigger] Failed to extract text from rendered tooltip! ', error);
        return '';
      }
    }
    addAriaAttributes() {
      if (!isPlatformBrowser(this.platformId)) return;
      this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-describedby', this.tooltipId);
      const tabIndex = this.elementRef.nativeElement.getAttribute('tabindex');
      if (tabIndex === null) {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', '0');
      }
    }
    removeVisuallyHiddenElement() {
      if (this.visuallyHiddenElement && this.elementRef?.nativeElement) {
        try {
          this.renderer.removeChild(this.elementRef.nativeElement, this.visuallyHiddenElement);
        } catch (error) {
          console.warn('Could not remove visually hidden element:', error);
        }
        this.visuallyHiddenElement = null;
      }
    }
    closeTooltip() {
      this.open.set(false);
      this.tooltipTriggerOpen.set(false);
      if (this.tooltipTrigger() === 'click') {
        this.tooltipTrigger.set('hover');
      }
    }
    addGlobalClickListener() {
      if (!isPlatformBrowser(this.platformId) || this.globalClickListener) return;
      this.globalClickListener = this.renderer.listen('document', 'click', event => {
        if (!this.open()) return;
        // Check if click is inside tooltip or trigger element
        const triggerEl = this.elementRef.nativeElement;
        const tooltipEl = this.tooltipElement;
        if (triggerEl.contains(event.target)) {
          return; // Click was on trigger element
        }
        if (tooltipEl && tooltipEl.contains(event.target)) {
          return; // Click was inside tooltip
        }
        // Click was outside both - close the tooltip
        this.closeTooltip();
      });
    }
    removeGlobalClickListener() {
      if (this.globalClickListener) {
        this.globalClickListener();
        this.globalClickListener = null;
      }
    }
    startObservingTooltip() {
      if (!isPlatformBrowser(this.platformId)) return;
      if (this.observer) return;
      this.observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          if (mutation.addedNodes.length) {
            this.findTooltipAndAttachCloseButton();
            this.stopObservingTooltip();
            break;
          }
        }
      });
      this.observer.observe(this.globalDocument.body, {
        childList: true,
        subtree: true
      });
      setTimeout(() => {
        if (this.observer) {
          this.findTooltipAndAttachCloseButton();
        }
      }, 0);
    }
    stopObservingTooltip() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
    findTooltipAndAttachCloseButton() {
      if (!isPlatformBrowser(this.platformId)) return;
      const tooltips = this.globalDocument.querySelectorAll('[sparkTooltip]');
      for (let i = 0; i < tooltips.length; i++) {
        const tooltip = tooltips[i];
        if (this.isTooltipForThisDirective(tooltip)) {
          this.tooltipElement = tooltip;
          this.updateTooltipClasses(this.placement());
          if (this.visuallyHiddenElement && !this.tooltipAccessibleText()) {
            const extractedText = this.extractTextFromRenderedTooltip();
            if (extractedText) {
              this.renderer.setProperty(this.visuallyHiddenElement, 'textContent', extractedText);
            }
          }
          if (this.tooltipWithArrow()) {
            this.addArrow(tooltip);
          }
          if (this.tooltipWithClose()) {
            const existingButton = tooltip.querySelector('.tooltip-close-btn');
            if (!existingButton) {
              this.addCloseButton(tooltip);
            }
          }
          break;
        }
      }
    }
    isTooltipForThisDirective(tooltip) {
      if (!isPlatformBrowser(this.platformId)) return false;
      const triggerRect = this.elementRef.nativeElement.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const isNearby = Math.abs(triggerRect.left - tooltipRect.left) < 150 && Math.abs(triggerRect.top - tooltipRect.top) < 150;
      return isNearby;
    }
    updateTooltipClasses(placement) {
      if (!this.tooltipElement) return;
      const tooltipClasses = tooltip({
        placement
      });
      this.tooltipElement.className = [...tooltipClasses.split(' ')].join(' ');
      if (this.arrowElement) {
        const arrowClasses = tooltipArrow({
          placement
        });
        this.arrowElement.className = ['tooltip-arrow', ...arrowClasses.split(' ')].join(' ');
      }
    }
    addArrow(tooltip) {
      if (!isPlatformBrowser(this.platformId) || !this.tooltipWithArrow()) return;
      let arrow = tooltip.querySelector('.tooltip-arrow');
      if (arrow) {
        this.arrowElement = arrow;
      } else {
        arrow = this.renderer.createElement('div');
        this.renderer.addClass(arrow, 'tooltip-arrow');
        this.renderer.appendChild(tooltip, arrow);
        this.arrowElement = arrow;
      }
      const arrowClasses = tooltipArrow({
        placement: this.placement()
      });
      arrowClasses.split(' ').forEach(cls => {
        if (cls) this.renderer.addClass(this.arrowElement, cls);
      });
    }
    addCloseButton(tooltip) {
      if (!isPlatformBrowser(this.platformId) || !this.tooltipWithClose()) return;
      const wrapper = this.renderer.createElement('div');
      this.renderer.addClass(wrapper, 'tooltip-wrapper');
      tw(['flex', 'gap-xs', 'items-center', 'justify-between', 'w-full']).forEach(className => this.renderer.addClass(wrapper, className));
      if (tooltip.firstChild) {
        this.renderer.appendChild(wrapper, tooltip.firstChild);
      }
      const closeButton = this.renderer.createElement('button');
      this.renderer.addClass(closeButton, 'tooltip-close-btn');
      this.renderer.setProperty(closeButton, 'textContent', '✕');
      tw(['flex', 'focus:outline-none', 'items-center', 'justify-center', 'size-[20px]', 'text-inverse', 'text-sm']).forEach(className => this.renderer.addClass(closeButton, className));
      const closeHandler = this.renderer.listen(closeButton, 'click', event => {
        event.stopPropagation();
        event.preventDefault();
        this.closeTooltip();
      });
      this.cleanupListeners.push(closeHandler);
      this.renderer.appendChild(wrapper, closeButton);
      this.renderer.appendChild(tooltip, wrapper);
    }
    onFocus() {
      this.tooltipTrigger.set('focus');
      this.open.set(true);
      this.tooltipTriggerOpen.set(true);
    }
    onEscape() {
      if (this.open()) {
        this.closeTooltip();
      }
    }
    onClick() {
      this.tooltipTrigger.set('click');
      this.open.set(true);
      this.tooltipTriggerOpen.set(true);
    }
    onMouseEnter() {
      if (this.tooltipTrigger() === 'hover') {
        this.open.set(true);
        this.tooltipTriggerOpen.set(true);
      }
    }
    onMouseLeave() {
      if (this.tooltipWithClose()) {
        this.open.set(true);
      }
      if (this.tooltipTrigger() === 'hover' && !this.tooltipWithClose()) {
        this.closeTooltip();
      }
    }
    onBlur() {
      if (!this.tooltipWithClose()) {
        this.tooltipTriggerOpen.set(false);
        this.open.set(false);
      }
    }
    static ɵfac = function TooltipTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipTriggerDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TooltipTriggerDirective,
      selectors: [["", "sparkTooltipTrigger", ""]],
      hostBindings: function TooltipTriggerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function TooltipTriggerDirective_mouseenter_HostBindingHandler() {
            return ctx.onMouseEnter();
          })("mouseleave", function TooltipTriggerDirective_mouseleave_HostBindingHandler() {
            return ctx.onMouseLeave();
          })("click", function TooltipTriggerDirective_click_HostBindingHandler() {
            return ctx.onClick();
          })("blur", function TooltipTriggerDirective_blur_HostBindingHandler() {
            return ctx.onBlur();
          })("focus", function TooltipTriggerDirective_focus_HostBindingHandler() {
            return ctx.onFocus();
          })("keydown.escape", function TooltipTriggerDirective_keydown_escape_HostBindingHandler() {
            return ctx.onEscape();
          });
        }
      },
      inputs: {
        tooltip: [1, "sparkTooltipTrigger", "tooltip"],
        flip: [1, "flip"],
        placement: [1, "tooltipPlacement", "placement"],
        tooltipWithArrow: [1, "tooltipWithArrow"],
        tooltipWithClose: [1, "tooltipWithClose"],
        tooltipTriggerOpen: [1, "tooltipTriggerOpen"],
        tooltipTrigger: [1, "tooltipTrigger"],
        tooltipAccessibleText: [1, "tooltipAccessibleText"]
      },
      outputs: {
        tooltipTriggerOpen: "tooltipTriggerOpenChange",
        tooltipTrigger: "tooltipTriggerChange"
      },
      exportAs: ["sparkTooltipTrigger"],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NgpTooltipTriggerToken,
        useExisting: TooltipTriggerDirective
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return TooltipTriggerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputModule = /*#__PURE__*/(() => {
  class InputModule {
    static ɵfac = function InputModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InputModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NgIconsModule.withIcons({
        faCircleXmark,
        faEye,
        faEyeSlash
      })]
    });
  }
  return InputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormFieldDirective = /*#__PURE__*/(() => {
  class FormFieldDirective {
    inputs;
    formFieldService = inject(FormFieldService);
    ngControl = contentChild(NgControl);
    ngAfterContentInit() {
      this.formFieldService.updateValue(this.ngControl()?.value);
      const activeInputs = this.inputs.filter(input => !input.formFieldIgnore);
      if (activeInputs.length > 1) {
        throw new Error('sparkFormField can only contain one active sparkInput. You can ignore an input by using `<input sparkInput [formFieldIgnore]="true" />`');
      }
    }
    static ɵfac = function FormFieldDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldDirective,
      selectors: [["", "sparkFormField", ""]],
      contentQueries: function FormFieldDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.ngControl, NgControl, 5);
          i0.ɵɵcontentQuery(dirIndex, _c0, 4);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputs = _t);
        }
      },
      hostAttrs: [1, "group", "relative", "w-fit", "[&:has([role=checkbox])]:flex", "[&:has([role=checkbox])]:items-center", "[&:has([role=checkbox])]:justify-center", "[&:has([role=checkbox])]:gap-sm"],
      features: [i0.ɵɵProvidersFeature([FormFieldService]), i0.ɵɵHostDirectivesFeature([i1$3.NgpFormField])]
    });
  }
  return FormFieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputLabelDirective = /*#__PURE__*/(() => {
  class InputLabelDirective {
    formFieldService = inject(FormFieldService, {
      optional: true
    });
    ngOnInit() {
      if (!this.formFieldService) {
        throw new Error(`
sparkInputLabel must be used within a sparkFormField like so: 

<div sparkFormField>
  <input id="myInput" sparkInput />
  <label for="myInput" sparkInputLabel>Label</label> <!-- The label must be placed after the input -->
</div>
`);
      }
    }
    get classes() {
      return inputLabel({
        floating: (this.formFieldService && this.formFieldService.value()?.length > 0) ?? false
      });
    }
    static ɵfac = function InputLabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputLabelDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InputLabelDirective,
      selectors: [["label", "sparkInputLabel", ""]],
      hostVars: 2,
      hostBindings: function InputLabelDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      features: [i0.ɵɵHostDirectivesFeature([i1$3.NgpLabel])]
    });
  }
  return InputLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormDescriptionDirective = /*#__PURE__*/(() => {
  class FormDescriptionDirective {
    hideIcon = false;
    iconName = 'faSolidCircleInfo';
    element = inject(ElementRef);
    renderer = inject(Renderer2);
    viewContainerRef = inject(ViewContainerRef);
    ngOnInit() {
      if (this.hideIcon) return;
      const host = this.element.nativeElement;
      const helperText = host.textContent?.trim() || '';
      if (!helperText) {
        throw new Error('sparkFormDescription missing content');
      }
      const iconRef = this.viewContainerRef.createComponent(NgIconComponent);
      iconRef.setInput('name', this.iconName);
      this.renderer.insertBefore(host, iconRef.location.nativeElement, host.firstChild);
    }
    static ɵfac = function FormDescriptionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormDescriptionDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormDescriptionDirective,
      selectors: [["", "sparkFormDescription", ""]],
      hostAttrs: [1, "flex", "items-center", "gap-xs", "pt-xs", "text-xs", "font-semibold", "leading-xs", "tracking-lg", "text-primary", "peer-disabled:text-disabled"],
      inputs: {
        hideIcon: "hideIcon",
        iconName: "iconName"
      },
      features: [i0.ɵɵHostDirectivesFeature([i1$3.NgpDescription])]
    });
  }
  return FormDescriptionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormErrorDirective = /*#__PURE__*/(() => {
  class FormErrorDirective {
    element = inject(ElementRef);
    renderer = inject(Renderer2);
    viewContainerRef = inject(ViewContainerRef);
    /**
     * Whether the error is with icon
     */
    withIcon = input(true, {
      transform: booleanAttribute
    });
    ngOnInit() {
      if (this.withIcon()) {
        this.addIcon();
      }
    }
    addIcon() {
      const host = this.element.nativeElement;
      const iconRef = this.viewContainerRef.createComponent(NgIconComponent);
      iconRef.setInput('name', 'faSolidTriangleExclamation');
      iconRef.location.nativeElement.classList.add(formErrorIcon);
      this.renderer.insertBefore(host, iconRef.location.nativeElement, host.firstChild);
    }
    static ɵfac = function FormErrorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormErrorDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormErrorDirective,
      selectors: [["", "sparkFormError", ""]],
      hostAttrs: [1, "hidden", "items-start", "gap-xs", "pt-xs", "text-xs", "font-semibold", "leading-xs", "tracking-lg", "text-critical", "group-[[data-has-error]]:flex", "data-[validator=\"fail\"]:data-[dirty]:flex", "peer-[[status=error]]:data-[validator=\"fail\"]:flex"],
      inputs: {
        withIcon: [1, "withIcon"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$3.NgpError,
        inputs: ["ngpErrorValidator", "validator"]
      }])]
    });
  }
  return FormErrorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalContentDirective = /*#__PURE__*/(() => {
  class ModalContentDirective {
    el;
    renderer;
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
    }
    ngAfterViewInit() {
      const hostElement = this.el.nativeElement;
      const isContentOverflowing = hostElement.scrollHeight > hostElement.clientHeight;
      if (isContentOverflowing) {
        this.renderer.setAttribute(hostElement, 'data-overflowing', 'true');
      } else {
        this.renderer.setAttribute(hostElement, 'data-overflowing', 'false');
      }
    }
    static ɵfac = function ModalContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalContentDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalContentDirective,
      selectors: [["", "sparkModalContent", ""]],
      hostAttrs: [1, "peer", "flex", "flex-1", "flex-col", "gap-xl", "self-stretch", "overflow-y-auto", "p-xl"],
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([i1$4.NgpDialogDescription])]
    });
  }
  return ModalContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalCloseButtonComponent = /*#__PURE__*/(() => {
  class ModalCloseButtonComponent {
    modalId = signal('');
    // eslint-disable-next-line @angular-eslint/no-output-native
    close = new EventEmitter();
    get classes() {
      return modalCloseButtonWrapper;
    }
    get closeButtonClasses() {
      return modalCloseButton;
    }
    onClick() {
      this.close.emit();
    }
    static ɵfac = function ModalCloseButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalCloseButtonComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalCloseButtonComponent,
      selectors: [["spark-modal-close-button"]],
      hostVars: 2,
      hostBindings: function ModalCloseButtonComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      outputs: {
        close: "close"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["sparkButton", "", "type", "button", "background", "outline", "size", "small", "aria-label", "Close", 3, "click"], ["name", "faSolidXmark"]],
      template: function ModalCloseButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function ModalCloseButtonComponent_Template_button_click_0_listener() {
            return ctx.onClick();
          });
          i0.ɵɵelement(1, "ng-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.closeButtonClasses);
          i0.ɵɵattribute("data-testid", "qa-" + ctx.modalId() + "-close-button");
        }
      },
      dependencies: [i1$1.NgIcon, ButtonDirective],
      encapsulation: 2
    });
  }
  return ModalCloseButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MOBILE_BREAKPOINT = 768;
const SWIPE_DOWN_THRESHOLD = 100;
let ModalDirective = /*#__PURE__*/(() => {
  class ModalDirective {
    size = 'medium';
    isModal = true;
    injectedDialogRef = inject(NgpDialog);
    viewContainerRef = inject(ViewContainerRef);
    elRef = inject(ElementRef);
    renderer = inject(Renderer2);
    platformId = inject(PLATFORM_ID);
    touchStartY = 0;
    touchEndY = 0;
    isMobile = computed(() => isPlatformBrowser(this.platformId) && window.innerWidth < MOBILE_BREAKPOINT);
    get classes() {
      return modal({
        size: this.size
      });
    }
    ngOnInit() {
      const host = this.elRef.nativeElement;
      const closeButtonRef = this.viewContainerRef.createComponent(ModalCloseButtonComponent);
      this.renderer.insertBefore(host, closeButtonRef.location.nativeElement, host.firstChild);
      closeButtonRef.instance.modalId.set(this.injectedDialogRef.id());
      closeButtonRef.instance.close.subscribe(() => {
        this.injectedDialogRef.close();
      });
    }
    onTouchStart(event) {
      this.touchStartY = event.touches[0].clientY;
    }
    onTouchMove(event) {
      this.touchEndY = event.touches[0].clientY;
    }
    onTouchEnd() {
      if (this.isMobile() && this.touchEndY - this.touchStartY > SWIPE_DOWN_THRESHOLD) {
        this.injectedDialogRef.close();
      }
    }
    static ɵfac = function ModalDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalDirective,
      selectors: [["", "sparkModal", ""]],
      hostVars: 2,
      hostBindings: function ModalDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("touchstart", function ModalDirective_touchstart_HostBindingHandler($event) {
            return ctx.onTouchStart($event);
          })("touchmove", function ModalDirective_touchmove_HostBindingHandler($event) {
            return ctx.onTouchMove($event);
          })("touchend", function ModalDirective_touchend_HostBindingHandler() {
            return ctx.onTouchEnd();
          });
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      inputs: {
        size: "size",
        isModal: [2, "isModal", "isModal", booleanAttribute]
      },
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$4.NgpDialog,
        inputs: ["ngpDialogModal", "isModal", "ngpDialogRole", "role"]
      }])]
    });
  }
  return ModalDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalTitleDirective = /*#__PURE__*/(() => {
  class ModalTitleDirective {
    static ɵfac = function ModalTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalTitleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalTitleDirective,
      selectors: [["", "sparkModalTitle", ""]],
      hostAttrs: [1, "border-b", "relative", "flex", "w-full", "items-baseline", "gap-md", "border-light", "p-xl", "pr-[56px]", "text-xl", "font-bold", "leading-lg", "text-primary", "md:pr-xl"],
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([i1$4.NgpDialogTitle])]
    });
  }
  return ModalTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalOverlayDirective = /*#__PURE__*/(() => {
  class ModalOverlayDirective {
    backdropDismiss = true;
    dialogRef = injectDialogRef();
    close() {
      if (this.backdropDismiss) {
        this.dialogRef.close();
      }
    }
    static ɵfac = function ModalOverlayDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalOverlayDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalOverlayDirective,
      selectors: [["", "sparkModalOverlay", ""]],
      hostAttrs: [1, "fixed", "inset-none", "flex", "animate-fade-in-300", "items-center", "justify-center", "bg-tertiary/50", "backdrop-blur-sm"],
      hostBindings: function ModalOverlayDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ModalOverlayDirective_click_HostBindingHandler() {
            return ctx.close();
          });
        }
      },
      inputs: {
        backdropDismiss: [2, "backdropDismiss", "backdropDismiss", booleanAttribute]
      },
      standalone: false
    });
  }
  return ModalOverlayDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalFooterDirective = /*#__PURE__*/(() => {
  class ModalFooterDirective {
    static ɵfac = function ModalFooterDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalFooterDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalFooterDirective,
      selectors: [["", "sparkModalFooter", ""]],
      hostAttrs: [1, "border-t", "flex", "w-full", "flex-col", "items-center", "gap-md", "self-stretch", "rounded-b-2xs", "border-light", "p-xl", "peer-[[data-overflowing=\"true\"]]:shadow-[0px_-4px_14px_0px_rgba(0,0,0,0.10)]", "md:flex-row", "md:justify-between", "md:self-stretch"],
      standalone: false
    });
  }
  return ModalFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalFooterContentDirective = /*#__PURE__*/(() => {
  class ModalFooterContentDirective {
    static ɵfac = function ModalFooterContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalFooterContentDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalFooterContentDirective,
      selectors: [["", "sparkModalFooterContent", ""]],
      hostAttrs: [1, "order-last", "md:order-first"],
      standalone: false
    });
  }
  return ModalFooterContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalFooterControlsDirective = /*#__PURE__*/(() => {
  class ModalFooterControlsDirective {
    static ɵfac = function ModalFooterControlsDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalFooterControlsDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalFooterControlsDirective,
      selectors: [["", "sparkModalFooterControls", ""]],
      hostAttrs: [1, "flex", "flex-col", "gap-md", "self-stretch", "md:flex-row", "md:justify-end", "md:self-stretch"],
      standalone: false
    });
  }
  return ModalFooterControlsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalTriggerDirective = /*#__PURE__*/(() => {
  class ModalTriggerDirective {
    static ɵfac = function ModalTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalTriggerDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ModalTriggerDirective,
      selectors: [["", "sparkModalTrigger", ""]],
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$4.NgpDialogTrigger,
        inputs: ["ngpDialogTrigger", "sparkModalTrigger"]
      }])]
    });
  }
  return ModalTriggerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalModule = /*#__PURE__*/(() => {
  class ModalModule {
    static ɵfac = function ModalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ModalModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NgIconsModule.withIcons({
        faSolidXmark
      }), CommonModule]
    });
  }
  return ModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const iconProviders = provideIcons({
  faCircleCheck,
  faSolidXmark,
  faCircleXmark,
  bootstrapExclamationTriangle,
  faSolidCircleInfo,
  ionInformationCircleOutline
});
const toastVariantIcons = {
  success: 'faCircleCheck',
  error: 'faCircleXmark',
  warning: 'bootstrapExclamationTriangle',
  info: 'ionInformationCircleOutline'
};
const TOAST_DURATION_LONG = 6000;
const TOAST_DURATION_DEFAULT = 3000;
let ToastDirective = /*#__PURE__*/(() => {
  class ToastDirective {
    toast = inject(NgpToast);
    ngAfterViewInit() {
      this.toast.show();
    }
    static ɵfac = function ToastDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ToastDirective,
      selectors: [["", "sparkToast", ""]],
      exportAs: ["sparkToast"],
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$5.NgpToast,
        inputs: ["ngpToastGravity", "gravity", "ngpToastPosition", "position", "ngpToastDuration", "duration", "ngpToastAriaLive", "ariaLive", "ngpToastStopOnHover", "stopOnHover"]
      }])]
    });
  }
  return ToastDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwipeDirective = /*#__PURE__*/(() => {
  class SwipeDirective {
    el = inject(ElementRef);
    swipeLeft = new EventEmitter();
    swipeRight = new EventEmitter();
    swipeUp = new EventEmitter();
    swipeDown = new EventEmitter();
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    minSwipeDistance = 50;
    onTouchStart(event) {
      const touch = event.changedTouches[0];
      this.touchStartX = touch.screenX;
      this.touchStartY = touch.screenY;
    }
    onTouchEnd(event) {
      const touch = event.changedTouches[0];
      this.touchEndX = touch.screenX;
      this.touchEndY = touch.screenY;
      this.detectSwipe(event);
    }
    detectSwipe(event) {
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      const distance = isHorizontalSwipe ? Math.abs(deltaX) : Math.abs(deltaY);
      if (distance < this.minSwipeDistance) return;
      const direction = isHorizontalSwipe ? deltaX > 0 ? 'Right' : 'Left' : deltaY > 0 ? 'Down' : 'Up';
      this.emitSwipe(direction, event);
    }
    emitSwipe(direction, event) {
      const dataAttr = direction.toLowerCase();
      this.el.nativeElement.setAttribute(`data-swipe-${dataAttr}`, 'true');
      this[`swipe${direction}`].emit(event);
    }
    static ɵfac = function SwipeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SwipeDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SwipeDirective,
      selectors: [["", "sparkSwipe", ""]],
      hostBindings: function SwipeDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("touchstart", function SwipeDirective_touchstart_HostBindingHandler($event) {
            return ctx.onTouchStart($event);
          })("touchend", function SwipeDirective_touchend_HostBindingHandler($event) {
            return ctx.onTouchEnd($event);
          });
        }
      },
      outputs: {
        swipeLeft: "swipeLeft",
        swipeRight: "swipeRight",
        swipeUp: "swipeUp",
        swipeDown: "swipeDown"
      }
    });
  }
  return SwipeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastComponent = /*#__PURE__*/(() => {
  class ToastComponent {
    dismissBtn;
    toast;
    toastDuration = computed(() => this.toast.duration ?? this.toastTimerBasedOnText);
    get toastTimerBasedOnText() {
      return this.toast.message.length >= 75 ? TOAST_DURATION_LONG : TOAST_DURATION_DEFAULT;
    }
    get ariaLive() {
      return this.toast?.type === 'error' ? 'assertive' : 'polite';
    }
    get toastStyles() {
      return toast({
        type: this.toast?.type,
        hasTitle: !!this.toast?.title,
        hasActions: !!this.toast?.actions?.length
      });
    }
    get iconBasedOnVariant() {
      return toastVariantIcons[this.toast.type ?? 'info'];
    }
    trackByLabel(index, action) {
      return action.label;
    }
    dismissToast() {
      this.scheduleDismiss(() => {
        this.dismissBtn?.nativeElement?.click();
      });
    }
    handleDismiss(dismissFn) {
      this.scheduleDismiss(dismissFn);
    }
    scheduleDismiss(action) {
      setTimeout(action, 100);
    }
    static ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToastComponent,
      selectors: [["spark-toast"]],
      viewQuery: function ToastComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dismissBtn = _t.first);
        }
      },
      hostBindings: function ToastComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.escape", function ToastComponent_keydown_escape_HostBindingHandler($event) {
            return ctx.dismissToast($event);
          });
        }
      },
      features: [i0.ɵɵProvidersFeature([], [iconProviders])],
      decls: 2,
      vars: 2,
      consts: [["toastDirective", "sparkToast"], ["toastContainer", ""], ["dismissBtn", ""], ["sparkToast", "", "gravity", "bottom", "position", "center", 3, "ariaLive", "duration"], ["tabindex", "0", "sparkSwipe", "", 3, "swipeLeft", "keydown.esc", "ngClass"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "flex", "flex-col"], ["class", "font-bold", 4, "ngIf"], ["class", "flex gap-md", 4, "ngIf"], ["type", "button", "aria-label", "Dismiss notification", "data-testid", "toast-dismiss", 3, "click", "ngClass"], ["name", "faSolidXmark"], [3, "name"], [1, "font-bold"], [1, "flex", "gap-md"], ["type", "button", 3, "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", 3, "click", "ngClass"]],
      template: function ToastComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ToastComponent_ng_template_0_Template, 12, 7, "ng-template", 3, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ariaLive", ctx.ariaLive)("duration", ctx.toastDuration());
        }
      },
      dependencies: [CommonModule, i1$6.NgClass, i1$6.NgForOf, i1$6.NgIf, ToastDirective, NgIcon, SwipeDirective],
      encapsulation: 2
    });
  }
  return ToastComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastService = /*#__PURE__*/(() => {
  class ToastService {
    appRef;
    _toasts = [];
    defaultToast = {
      type: 'info',
      duration: 3000,
      showIcon: true
    };
    constructor(appRef) {
      this.appRef = appRef;
    }
    get toasts() {
      return this._toasts;
    }
    /**
     * Opens a toast notification.
     *
     * @param {Object} toast - Partial configuration object of type {@link ToastConfig}.
     *
     *  * Required:
     * - `toast.message`
     *
     * Defaults:
     *
     * `{
     *   variant: 'info',
     *   duration: 3000,
     *   showIcon: true
     * }`
     *
     */
    show(toast) {
      this.clearToasts();
      const componentRef = createComponent(ToastComponent, {
        environmentInjector: this.appRef.injector
      });
      // Create new object without mutating default config
      componentRef.instance.toast = Object.assign({}, this.defaultToast, toast);
      this.appRef.attachView(componentRef.hostView);
      this._toasts.push(componentRef);
    }
    clearToasts() {
      this._toasts.forEach(toastRef => {
        toastRef.instance.dismissToast();
      });
      this._toasts = [];
    }
    static ɵfac = function ToastService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastService)(i0.ɵɵinject(i0.ApplicationRef));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToastService,
      factory: ToastService.ɵfac,
      providedIn: 'root'
    });
  }
  return ToastService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SparkDividerDirective = /*#__PURE__*/(() => {
  class SparkDividerDirective {
    orientation = 'horizontal';
    color = 'light';
    bold = false;
    rounded = false;
    get classes() {
      return divider({
        orientation: this.orientation,
        color: this.color,
        bold: this.bold,
        rounded: this.rounded
      });
    }
    static ɵfac = function SparkDividerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SparkDividerDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SparkDividerDirective,
      selectors: [["", "sparkDivider", ""]],
      hostAttrs: ["role", "separator"],
      hostVars: 3,
      hostBindings: function SparkDividerDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-orientation", ctx.orientation);
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      inputs: {
        orientation: "orientation",
        color: "color",
        bold: "bold",
        rounded: "rounded"
      }
    });
  }
  return SparkDividerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardDirective = /*#__PURE__*/(() => {
  class CardDirective {
    elementRef = inject(ElementRef);
    cardRounded = input();
    cardShadow = input();
    cardBordered = input();
    cardInteractive = input();
    cardDisabled = input();
    classes = computed(() => card({
      cardBordered: this.cardBordered(),
      cardRounded: this.cardRounded(),
      cardShadow: this.cardShadow(),
      cardInteractive: this.cardInteractive(),
      cardDisabled: this.cardDisabled()
    }));
    tabIndex = computed(() => this.cardInteractive() ? '0' : '-1');
    ariaDisabled = computed(() => this.cardDisabled() ? 'true' : null);
    ngAfterViewInit() {
      if (this.cardInteractive()) {
        if (!this.elementRef.nativeElement.hasAttribute('aria-labelledby')) {
          throw new Error(`
          [sparkCard] Accessibility Error: Host element must have
          an aria-labelledby attribute. Please add this attribute referencing
          the ID of a title element.
        `);
        }
      }
    }
    static ɵfac = function CardDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CardDirective,
      selectors: [["", "sparkCard", ""]],
      hostVars: 4,
      hostBindings: function CardDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.tabIndex())("aria-disabled", ctx.ariaDisabled());
          i0.ɵɵclassMap(ctx.classes());
        }
      },
      inputs: {
        cardRounded: [1, "cardRounded"],
        cardShadow: [1, "cardShadow"],
        cardBordered: [1, "cardBordered"],
        cardInteractive: [1, "cardInteractive"],
        cardDisabled: [1, "cardDisabled"]
      }
    });
  }
  return CardDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxIconComponent = /*#__PURE__*/(() => {
  class CheckboxIconComponent {
    static ɵfac = function CheckboxIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckboxIconComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CheckboxIconComponent,
      selectors: [["spark-checkbox-icon"]],
      hostAttrs: [1, "flex", "place-items-center"],
      features: [i0.ɵɵProvidersFeature([], [provideIcons({
        faSolidCheck
      })])],
      decls: 1,
      vars: 0,
      consts: [["name", "faSolidCheck", "aria-hidden", "true"]],
      template: function CheckboxIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "ng-icon", 0);
        }
      },
      dependencies: [NgIcon],
      encapsulation: 2
    });
  }
  return CheckboxIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxDirective = /*#__PURE__*/(() => {
  class CheckboxDirective {
    checkboxRef = inject(NgpCheckbox);
    formField = inject(NgpFormField, {
      optional: true
    });
    elementRef = inject(ElementRef);
    viewContainerRef = inject(ViewContainerRef);
    renderer = inject(Renderer2);
    platformId = inject(PLATFORM_ID);
    iconRef = null;
    focused = signal(false);
    lastInteractionWasKeyboard = signal(false);
    mouseDownListenerFn;
    keyDownListenerFn;
    /**
     * Whether the checkbox is invalid.
     */
    hasError = input(false, {
      transform: booleanAttribute
    });
    /**
     * Checks whether the checkbox is invalid.
     */
    isInvalid = computed(() => {
      const isInvalid = this.checkboxRef.required() && !this.checkboxRef.checked() && this.hasError();
      const targetId = this.formField?.formControl();
      if (isPlatformBrowser(this.platformId) && targetId) {
        const target = document.getElementById(targetId)?.parentElement;
        if (target?.hasAttribute('sparkFormField')) {
          target.toggleAttribute('data-has-error', isInvalid);
        }
      }
      return isInvalid;
    });
    ngOnInit() {
      this.registerFocusListeners();
      this.syncIconWithState();
      this.checkboxRef.checkedChange.subscribe(this.onCheckedChange.bind(this));
    }
    /**
     * Registers focus listeners to track keyboard and mouse interactions.
     * This resolves an inconsistency where the checkbox is focused on keyboard or label click.
     */
    registerFocusListeners() {
      this.mouseDownListenerFn = this.renderer.listen('document', 'mousedown', () => {
        this.lastInteractionWasKeyboard.set(false);
      });
      this.keyDownListenerFn = this.renderer.listen('document', 'keydown', event => {
        if (event.key === 'Tab') {
          this.lastInteractionWasKeyboard.set(true);
        }
      });
    }
    onFocus() {
      if (this.lastInteractionWasKeyboard()) {
        this.focused.set(true);
      }
    }
    syncIconWithState() {
      if (this.checkboxRef.checked()) {
        this.addCheckIcon();
      }
    }
    addCheckIcon() {
      this.iconRef = this.viewContainerRef.createComponent(CheckboxIconComponent);
      this.renderer.appendChild(this.elementRef.nativeElement, this.iconRef.location.nativeElement);
    }
    onCheckedChange(checked) {
      if (this.checkboxRef.disabled()) {
        return;
      }
      if (checked) {
        if (!this.iconRef) {
          this.addCheckIcon();
        }
      } else {
        if (this.iconRef) {
          this.iconRef.destroy();
          this.iconRef = null;
        }
      }
    }
    ngOnDestroy() {
      if (this.iconRef) {
        this.iconRef.destroy();
      }
      if (this.mouseDownListenerFn) {
        this.mouseDownListenerFn();
      }
      if (this.keyDownListenerFn) {
        this.keyDownListenerFn();
      }
    }
    static ɵfac = function CheckboxDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckboxDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CheckboxDirective,
      selectors: [["", "sparkCheckbox", ""]],
      hostAttrs: [1, "peer", "my-[0.19rem]", "flex", "size-[18px]", "flex-shrink-0", "items-center", "justify-center", "self-start", "rounded-2xs", "border-md", "border-tertiary", "bg-transparent", "p-none", "text-xs", "text-inverse", "outline-none", "data-[hover]:cursor-pointer", "data-[hover]:border-neutral-hover", "data-[checked]:border-brand", "data-[checked]:data-[hover]:border-brand-hover", "data-[checked]:bg-brand", "data-[checked]:data-[hover]:bg-brand-hover", "data-[disabled]:border-neutral-disabled", "data-[disabled]:data-[checked]:bg-support-disabled", "data-[disabled]:text-inverse", "data-[invalid]:border-critical", "data-[focused]:outline-2", "data-[focused]:outline-offset-2", "data-[focused]:outline-tertiary", "[&:user-invalid]:border-critical"],
      hostVars: 2,
      hostBindings: function CheckboxDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function CheckboxDirective_focus_HostBindingHandler() {
            return ctx.onFocus();
          })("blur", function CheckboxDirective_blur_HostBindingHandler() {
            return ctx.focused.set(false);
          })("mousedown", function CheckboxDirective_mousedown_HostBindingHandler() {
            return ctx.focused.set(false);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("data-invalid", ctx.isInvalid() ? "" : null)("data-focused", ctx.focused() ? "" : null);
        }
      },
      inputs: {
        hasError: [1, "hasError"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$7.NgpCheckbox,
        inputs: ["ngpCheckboxChecked", "checked", "ngpCheckboxDisabled", "disabled", "ngpCheckboxRequired", "required", "ngpCheckboxIndeterminate", "indeterminate"],
        outputs: ["ngpCheckboxCheckedChange", "checkedChange", "ngpCheckboxIndeterminateChange", "indeterminateChange"]
      }])]
    });
  }
  return CheckboxDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelDirective = /*#__PURE__*/(() => {
  class LabelDirective {
    formField = inject(NgpFormField, {
      optional: true
    });
    platformId = inject(PLATFORM_ID);
    size;
    get classes() {
      return label({
        size: this.size
      });
    }
    onHover(state) {
      // Lookup associated element via the known id
      const targetId = this.formField?.formControl();
      if (isPlatformBrowser(this.platformId)) {
        const target = document.getElementById(targetId);
        // Do nothing if the target is disabled
        const disabled = target.getAttribute('disabled');
        const ariaDisabled = target.getAttribute('aria-disabled');
        if (disabled === '' || disabled === 'true' || ariaDisabled === 'true') {
          return;
        }
        if (target instanceof HTMLElement && target.role === 'checkbox') {
          state ? target?.setAttribute('data-hover', '') : target?.removeAttribute('data-hover');
        }
      }
    }
    static ɵfac = function LabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LabelDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: LabelDirective,
      selectors: [["label", "sparkLabel", ""]],
      hostVars: 2,
      hostBindings: function LabelDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function LabelDirective_mouseenter_HostBindingHandler() {
            return ctx.onHover(true);
          })("mouseleave", function LabelDirective_mouseleave_HostBindingHandler() {
            return ctx.onHover(false);
          });
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes);
        }
      },
      inputs: {
        size: "size"
      },
      features: [i0.ɵɵHostDirectivesFeature([i1$3.NgpLabel])]
    });
  }
  return LabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionDirective = /*#__PURE__*/(() => {
  class AccordionDirective {
    accordion = inject(NgpAccordion);
    bordered = input(true);
    rounded = input(false, {
      transform: booleanAttribute
    });
    classes = computed(() => accordion({
      disabled: this.accordion.disabled()
    }));
    static ɵfac = function AccordionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AccordionDirective,
      selectors: [["", "sparkAccordion", ""]],
      hostAttrs: ["role", "tablist"],
      hostVars: 5,
      hostBindings: function AccordionDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-multiselectable", ctx.accordion.type() === "multiple")("aria-orientation", ctx.accordion.orientation())("aria-disabled", ctx.accordion.disabled());
          i0.ɵɵclassMap(ctx.classes());
        }
      },
      inputs: {
        bordered: [1, "bordered"],
        rounded: [1, "rounded"]
      },
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$8.NgpAccordion,
        inputs: ["ngpAccordionType", "type", "ngpAccordionCollapsible", "collapsible", "ngpAccordionValue", "value", "ngpAccordionDisabled", "disabled"],
        outputs: ["ngpAccordionValueChange", "valueChange"]
      }])]
    });
  }
  return AccordionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionTriggerDirective = /*#__PURE__*/(() => {
  class AccordionTriggerDirective {
    accordion = inject(NgpAccordion);
    item = inject(NgpAccordionItem);
    classes = computed(() => accordionTrigger());
    tabIndex = computed(() => {
      return this.item.disabled() || this.accordion.disabled() ? -1 : 0;
    });
    ariaDisabled = computed(() => {
      return this.item.disabled() || this.accordion.disabled() ? 'true' : null;
    });
    ariaLabel = 'Toggle section';
    static ɵfac = function AccordionTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionTriggerDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AccordionTriggerDirective,
      selectors: [["", "sparkAccordionTrigger", ""]],
      hostAttrs: ["role", "tab"],
      hostVars: 5,
      hostBindings: function AccordionTriggerDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.tabIndex())("aria-label", ctx.ariaLabel)("aria-disabled", ctx.ariaDisabled());
          i0.ɵɵclassMap(ctx.classes());
        }
      },
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$8.NgpAccordionTrigger,
        inputs: ["id", "id"]
      }])]
    });
  }
  return AccordionTriggerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionPanelDirective = /*#__PURE__*/(() => {
  class AccordionPanelDirective {
    accordion = inject(AccordionDirective, {
      optional: true
    });
    item = inject(NgpAccordionItem);
    classes = computed(() => accordionPanel({
      rounded: this.accordion?.rounded(),
      bordered: this.accordion?.bordered()
    }));
    static ɵfac = function AccordionPanelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionPanelDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AccordionPanelDirective,
      selectors: [["", "sparkAccordionPanel", ""]],
      hostAttrs: ["role", "presentation"],
      hostVars: 2,
      hostBindings: function AccordionPanelDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.classes());
        }
      },
      exportAs: ["sparkAccordionPanel"],
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$8.NgpAccordionItem,
        inputs: ["ngpAccordionItemValue", "value", "ngpAccordionItemDisabled", "disabled"]
      }])]
    });
  }
  return AccordionPanelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionContentDirective = /*#__PURE__*/(() => {
  class AccordionContentDirective {
    itemRef = inject(NgpAccordionItem);
    accordionContent = inject(NgpAccordionContent);
    className = accordionContent();
    height = computed(() => {
      return this.itemRef.open() ? this.accordionContent.height() : 0;
    });
    static ɵfac = function AccordionContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccordionContentDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AccordionContentDirective,
      selectors: [["", "sparkAccordionContent", ""]],
      hostAttrs: ["role", "tabpanel", "aria-live", "polite"],
      hostVars: 5,
      hostBindings: function AccordionContentDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", !ctx.itemRef.open());
          i0.ɵɵclassMap(ctx.className);
          i0.ɵɵstyleProp("height", ctx.height(), "px");
        }
      },
      standalone: false,
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i1$8.NgpAccordionContent,
        inputs: ["id", "id"]
      }])]
    });
  }
  return AccordionContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SparkAccordionModule = /*#__PURE__*/(() => {
  class SparkAccordionModule {
    static ɵfac = function SparkAccordionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SparkAccordionModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SparkAccordionModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NgIconsModule.withIcons({
        faSolidXmark
      })]
    });
  }
  return SparkAccordionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionContentDirective, AccordionDirective, AccordionPanelDirective, AccordionTriggerDirective, ButtonDirective, CardDirective, CheckboxDirective, FormDescriptionDirective, FormErrorDirective, FormFieldDirective, InputButtonsComponent, InputDirective, InputLabelDirective, InputModule, LabelDirective, ModalCloseButtonComponent, ModalContentDirective, ModalDirective, ModalFooterContentDirective, ModalFooterControlsDirective, ModalFooterDirective, ModalModule, ModalOverlayDirective, ModalTitleDirective, ModalTriggerDirective, SparkAccordionModule, SparkDividerDirective, ToastComponent, ToastService, TooltipDirective, TooltipTriggerDirective };
